<template>
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 9 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.99536 16.8267L1.40951 10.2408C0.631727 9.46302 0.631727 8.1903 1.40951 7.41252L7.99536 0.82666"
            stroke="currentColor"
            stroke-width="1.65289"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
